import axios from './http';

/**
 * 登录
 * @param {string} phone  手机号
 * @param {string} smsCaptcha 短信验证码
 * @param {string} imgCaptcha 英文验证码
 */
export function login(params) {
  return axios.post('core/public/cm-china/login', params);
}

/**
 * 获取手机验证码
 * @param {string} phone  手机号
 */
export function getPhoneCode(params, headers) {
  return axios.get('core/public/captcha/sms', { params, headers });
}
/**
 * 获取英文验证码
 * @param {string} phone  手机号
 */
export function getEnCode(params) {
  return axios.get('core/public/captcha/img', { params });
}
/**
 * 获取英文验证码
 * @param {string} phone  手机号
 */
export function showEnCode(params) {
  return axios.get('core/public/captcha/judge', { params });
}

/**
 * CM-China用户名密码登录
 * @param {string} username  用户名
 * @param {string} password 密码
 */
export function userNameLogin(params) {
  return axios.post('core/public/cm-china/username/login', params);
}
